interface HasLabel {
  label: string;
}

export const byLabel = (a?: HasLabel, b?: HasLabel) => {
  const a_label = (a?.label ?? '').toLowerCase();
  const b_label = (b?.label ?? '').toLowerCase();

  return a_label === b_label ? 0 : a_label > b_label ? 1 : -1;
};
